<div class="menu-dialog">
    <div class="menu-dialog__header">
        <div class="menu-dialog__header-text">
            <h2 class="menu-dialog__title">Menu Card</h2>
            <p class="menu-dialog__subtitle">Select items for each meal</p>
        </div>
        <button type="button" class="menu-dialog__close" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="menu-dialog__tabs-section" *ngIf="scenarioTabs.length">
        <div class="menu-dialog__tabs" role="tablist">
            <button type="button" class="menu-tab" *ngFor="let tab of scenarioTabs" role="tab"
                [class.menu-tab--active]="activeScenarioId === tab.scenarioId"
                [attr.aria-selected]="activeScenarioId === tab.scenarioId"
                (click)="selectScenario(tab.scenarioId)">
                <span class="menu-tab__icon-wrap">
                    <mat-icon class="menu-tab__icon">{{ tab.icon }}</mat-icon>
                </span>
                <span class="menu-tab__labels">
                    <span class="menu-tab__label-en">{{ tab.scenarioName }}</span>
                </span>
            </button>
        </div>

        <div class="menu-dialog__search-wrap">
            <mat-icon class="menu-dialog__search-icon">search</mat-icon>
            <input type="text" class="menu-dialog__search" [(ngModel)]="searchText" placeholder="Search items..."
                aria-label="Search items" />
        </div>
    </div>

    <div class="menu-dialog__body">
        <ng-container *ngIf="activeScenarioMenuItems.length; else emptyMenu">
            <div class="menu-section__head">
                <span class="menu-section__title">Selected Menu</span>
                <span class="menu-section__count">{{ activeScenarioSelectedCount }}</span>
            </div>

            <div class="menu-item menu-item--selected" *ngFor="let item of activeMenuItems">
                <div class="menu-item__text">
                    <div class="menu-item__name-en">{{ item.daysheetMenuItemName }}</div>
                </div>
            </div>

            <div class="menu-dialog__empty" *ngIf="!activeMenuItems.length && searchText.trim()">
                No menu items match your search.
            </div>
        </ng-container>

        <ng-template #emptyMenu>
            <div class="menu-dialog__empty" *ngIf="scenarioTabs.length">
                No menu items found for {{ activeScenarioName || 'this meal' }}.
            </div>
            <div class="menu-dialog__empty" *ngIf="!scenarioTabs.length">
                No menu card data available.
            </div>
        </ng-template>
    </div>

    <div class="menu-dialog__footer" *ngIf="scenarioTabs.length">
        <div class="menu-dialog__summary">
            Total selected items: <strong>{{ totalSelectedCount }}</strong>
            <span class="menu-dialog__meal-summary" *ngIf="activeScenarioSelectedCount && activeScenarioName">
                ({{ activeScenarioSelectedCount }} in {{ activeScenarioName }})
            </span>
        </div>
    </div>
</div>
